import AppointmentDetailDrawer from './AppointmentDetailDrawer'
export default AppointmentDetailDrawer